// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4542":"css/admin-app.6752","8001":"css/app.6752"}[chunkId] + ".css";
};